var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 47.0908C38.5435 47.0908 47.0908 38.5435 47.0908 27.9999C47.0908 17.4563 38.5435 8.90898 27.9999 8.90898C17.4563 8.90898 8.90898 17.4563 8.90898 27.9999C8.90898 38.5435 17.4563 47.0908 27.9999 47.0908ZM27.9999 49.6363C39.9493 49.6363 49.6362 39.9493 49.6362 27.9999C49.6362 16.0505 39.9493 6.36353 27.9999 6.36353C16.0505 6.36353 6.36353 16.0505 6.36353 27.9999C6.36353 39.9493 16.0505 49.6363 27.9999 49.6363Z",
    fill: "#00A88E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8182 28.0001C31.8182 30.1088 30.1088 31.8182 28.0001 31.8182C25.8913 31.8182 24.1819 30.1088 24.1819 28.0001C24.1819 25.8913 25.8913 24.1819 28.0001 24.1819C30.1088 24.1819 31.8182 25.8913 31.8182 28.0001Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0415 13.4915L37.2459 14.7642L29.2662 28.5855L27.0617 27.3128L35.0415 13.4915Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5454 29.2727L16.5454 26.7273L29.2727 26.7273L29.2727 29.2727L16.5454 29.2727Z",
    fill: "#1D1D1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90918 26.7273H12.7274V29.2728H8.90918V26.7273Z",
    fill: "#00A88E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2727 26.7273H47.0909V29.2728H43.2727V26.7273Z",
    fill: "#00A88E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7273 8.90918H29.2728V12.7274H26.7273V8.90918Z",
    fill: "#00A88E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7273 43.2727H29.2728V47.0909H26.7273V43.2727Z",
    fill: "#00A88E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenTime);
export default __webpack_public_path__ + "static/media/screen-time.1ffcc2d5e24d6d02d1814b27a644c8cf.svg";
export { ForwardRef as ReactComponent };